// Imports
import ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/noSourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".gold-icons-diseaseGoldIconContainer-17fc4{background-color:transparent;display:flex;flex-wrap:wrap;font-size:0;padding:.15rem 0 .05rem;text-align:-webkit-center}.gold-icons-diseaseGoldIconParent-a3917{display:flex;margin-bottom:.54rem;position:relative}.gold-icons-diseaseGoldIcon-6c8d9{height:.9rem;width:.9rem}.gold-icons-diseaseGoldIconTitle-7c5ff{color:#1f1f1f;font-size:.42rem;line-height:.42rem;overflow:hidden;padding-top:.27rem;text-align:center;text-overflow:ellipsis;white-space:nowrap}", ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"diseaseGoldIconContainer": "gold-icons-diseaseGoldIconContainer-17fc4",
	"diseaseGoldIconParent": "gold-icons-diseaseGoldIconParent-a3917",
	"diseaseGoldIcon": "gold-icons-diseaseGoldIcon-6c8d9",
	"diseaseGoldIconTitle": "gold-icons-diseaseGoldIconTitle-7c5ff"
};
export default ___CSS_LOADER_EXPORT___;
